import {useRouter} from 'next/router';
import type {FC} from 'react';
import {LOGIN} from '../../config/constants/routes';
import isAppWebView from '../../config/isAppWebView';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../core/entities/login/constants';
import {getMailAuthLinkWithParamsHooks} from '../services/getMailAuthLinkWithParamsHooks';

export const RegistBox: FC<{
  text?: string;
}> = ({text = '続きを読むには会員登録が必要です'}) => {
  const router = useRouter();
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});
  return (
    <div className="absolute w-full p-16 pc:w-2/3 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <div className="flex flex-col bg-white justify-center items-center p-16 rounded-16 shadow-modal gap-12">
        <p className="text-center text-black-1 text-base pc:whitespace-nowrap">
          {text}
        </p>
        <div className="flex gap-12">
          <div
            className="bg-gradient-to-r from-gradient-register-l to-gradient-register-r rounded-full px-16 py-8 text-base font-bold text-white cursor-pointer hover:opacity-60"
            onClick={() => {
              location.href = mailAuthLink;
            }}
          >
            会員登録
          </div>
          <div
            className="bg-white outline outline-2 outline-primary rounded-full px-16 py-8 text-base font-bold text-primary cursor-pointer hover:opacity-60"
            onClick={async () => {
              const path = `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`;
              if (isAppWebView()) {
                location.href = path;
              } else {
                await router.push(path);
              }
            }}
          >
            ログイン
          </div>
        </div>
      </div>
    </div>
  );
};
